import src from "IMAGE";
export default { src, width: 1200, height: 150, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AKujnf/Uzcb/t7Sz/8bAv//nZYT/5jJc/+keT//pOGP/iyEWzMYsWiMAAAAASUVORK5CYII="};
